import { useAuthStore } from '@vanialabs/core-auth';

export function initializeAuth() {
  const store = useAuthStore.getState();

  try {
    store.restoreSession();
  } catch {
    store.clearSession();
    store.setInitialized(true);
  }
}
